import { Card, CardContent, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type FeatureCardProps = {
  title: string;
  description: string;
  icon?: ReactNode;
};

export function FeatureCard({ title, description, icon }: FeatureCardProps) {
  return (
    <Card
      sx={{
        height: '100%',
        transition: 'box-shadow 200ms ease-out',
        '&:hover': { boxShadow: '0 4px 12px rgba(11,13,16,.06)' },
      }}
    >
      <CardContent>
        <Stack spacing={2}>
          {icon}
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
